import {Card} from "./card";
export class JobOpeningCard extends Card{
  company:string;
  constructor(title:string,summary:string,unid:string,urlId:string,company:string){
    super(title,summary,unid,urlId, null);
    this.company=company;
  }
}
